import { makeFetchSlice, fetchHomeDataThunk } from 'app/redux-fetch'
import { AppDispatch } from 'app/store'
import { cancelActiveSubscription } from 'features/home/api'
import { fetchHomeThunk } from 'features/home/slice'
import { fetchSubscriptionsThunk } from '../slice'

const cancelSubscriptionSlice = makeFetchSlice('cancelSubscription')

export const cancelSubscriptionReducer = cancelSubscriptionSlice.reducer
export const cancelSubscriptionActions = cancelSubscriptionSlice.actions

export const cancelSubscriptionThunk = (
  rootDomainId: string,
  homeId: string
) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchHomeDataThunk({
        dispatch,
        actions: cancelSubscriptionActions,
        asyncFunc: () => cancelActiveSubscription(rootDomainId, homeId),
      })

      await dispatch(fetchSubscriptionsThunk(homeId))
      await dispatch(fetchHomeThunk(homeId))
    } catch (error) {
      console.log('Error while cancel/downgrade subscription', homeId, error)
      throw new Error('Error while cancel/downgrade subscription')
    }
  }
}
